import React from 'react';
import { MailIcon } from 'lucide-react';
import { PRODUCT, SUPPORT_EMAIL } from '../data/woodworking';
import { PREMIUM } from '../data/premium';
export function Footer() {
  return <footer id="site-footer" className="border-t border-white/10 bg-charcoal-deep py-12 text-white" data-id="element-48" data-mp="32o4b2ak1486j">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-49" data-mp="36p6c8wxiaub5">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between" data-id="element-50" data-mp="36ppnjusnikg7">
          <div data-id="element-51" data-mp="3uftm3nqzfu0c">
            <p className="wordmark text-[1.1rem] text-ivory sm:text-[1.25rem]" data-id="element-52" data-mp="3ud7g3sjqpmk8">
              Woodworking Projects That Sell<sup className="ml-0.5 font-sans text-[0.5em] font-semibold" data-id="element-53" data-mp="3lecbgkwcgkj1">™</sup>
            </p>
            <p className="mt-2 text-[0.92rem] text-muted" data-id="element-54" data-mp="3qdf415v50ya4">{PRODUCT.descriptor}</p>
            <p className="label-tech mt-3 text-brass-light" data-id="element-55" data-mp="3qfjgwdb0l7mj">{PREMIUM.edition} · {PREMIUM.access}</p>
          </div>
          <div data-id="element-56" data-mp="2eya05yj9stox">
            <p className="label-tech text-muted" data-id="element-57" data-mp="2ey05hxna5ycw">Personal support</p>
            <a href={`mailto:${SUPPORT_EMAIL}`} className="mt-1 inline-flex min-h-[44px] items-center gap-2 text-[0.92rem] text-parchment hover:text-brass-light" data-id="element-58" data-mp="2ew734ujpa0ap">
              <MailIcon className="h-4 w-4 shrink-0 text-brass-light" aria-hidden data-id="element-59" data-mp="3gbqzkjsk4td0" />
              <span className="break-all" data-id="element-60" data-mp="3v7zuj95f0kjm">{SUPPORT_EMAIL}</span>
            </a>
          </div>
        </div>
        <div className="mt-10 flex flex-col gap-1.5 border-t border-white/10 pt-6 text-[0.82rem] text-muted sm:flex-row sm:flex-wrap sm:gap-x-4" data-id="element-61" data-mp="3q7llbns2v4k0">
          <p data-id="element-62" data-mp="80ntqkb6ysde">© 2026 WOODWORKING PROJECTS THAT SELL™. All rights reserved.</p>
          <p data-id="element-63" data-mp="33nmi62lvjkp">Build & sell rights for the physical pieces. Digital files may not be shared or resold.</p>
        </div>
      </div>
    </footer>;
}